require('./loansCreditsMortgagesProductBanners.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const uniq = require('lodash/array/uniq');
const get = require('lodash/object/get');
const { isNull } = require('lodash');
const { withRouter } = require("react-router-dom");
//@components
const ProductBanner = require('components/commons/productBanner/productBanner');
const { getLoansCreditsMortgagesProductBanners } = require('../../../loansConstants/loansCreditsMortgagesProductBanners');
const { RetailLoanCarousel } = require('../../contracts/contractRetailLoan/retailLoanCarousel/retailLoanCarousel');
//@core
const { FormattedText, formatText, hasTranslation } = require('core/i18n').i18n;
//@helpers
const { nonNumericFilter, toCamelCase } = require('utilities/stringHelper');
const { getFormattedString, formatNumber, formatAmount } = require('utilities/currencyHelper');
const { getCollectiveByParams } = require('utilities/collectivesHelper');
const { PROC_RETAIL_LOAN, EVENT_VIEW_ALL, recordCommercialSpaceV2 } = require('utilities/tagging');
const { recordEasyLoanCBannerMoreInfo } = require('../../contracts/contractEasyLoanTypeC/analytics/contractEasyLoanTypeC.tracking');
//@constants
const {
    retailLoanCommons,
    configOkLoansCarousel,
    LOAN_MORTGAGES_RETAIL_BANNER,
    LOANS_MORTGAGES_EASY_LOAN,
    LOANS_MORTGAGES_MORTGAGE_LOAN,
} = require('../../../loansConstants/index');
const PAYROLL_LOAN_RECORD_STATUS = require('../../../loansConstants/payrollLoanRecordStatus');
const { ENABLE_RETAIL_LOAN_HIRE_IN_CC } = require('constants/contactCenter/retailLoanConstants');
const {
    ACTION_EVENT_VIEW,
    COMMERCIAL_ADS_ACTION_EVENT,
    COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
    COMMERCIAL_ADS_TEALIUM_EVENT,
    COMMERCIAL_WAFER_ADS_EVENT_CATEGORY,
} = require('constants/tagging');
const { bannerShow } = require('../../../loansUtilities/bannerStatusHelper');

class LoansCreditsMortgagesProductBanners extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAllBannersTagged: false,
            loansAndMortgagesBannersData: []
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.redirectToBuyItem = this.redirectToBuyItem.bind(this);
    }

    buildEasyAmount(amount) {
        const { immContractEasyLoan } = this.props;

        return {
            amount,
            currency: immContractEasyLoan.get('currency'),
            decimalsLength: 0
        };
    }

    getCardType(immLoan) {
        const newProduct = immLoan.get('newProduct');
        const productSubType = immLoan.get('productSubType');
        let cardType = nonNumericFilter(newProduct + productSubType);

        return cardType;
    }

    getProductBannersOrder(userOwnedProductBannersCode) {
        const { immFlagBasedFeatures, immPayrollLoanRecordStatus } = this.props;
        const accountTypesContractedByUser = [];
        let accountTypesNonContractedByUser = [];
        const productSubType = immPayrollLoanRecordStatus.get('productSubType');
        getLoansCreditsMortgagesProductBanners(productSubType).map(banner => {

            const featureFlag = banner.featureFlag === null ? true : immFlagBasedFeatures.get(banner.featureFlag);

            if (banner.id !== LOANS_MORTGAGES_MORTGAGE_LOAN && !featureFlag) {
                return;
            }
            if (banner.id === LOANS_MORTGAGES_EASY_LOAN && immPayrollLoanRecordStatus.get('error') !== false) {
                return;
            }
            if (userOwnedProductBannersCode.includes(banner.id)) {
                accountTypesContractedByUser.push(banner);
            } else {
                accountTypesNonContractedByUser.push(banner);
            }
        });

        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    getUserOwnedProductBannersCode() {
        const output = [];

        if (this.props.immCredits.get('hasPregrantedCredit')) {
            output.push('pregrantedCredit');
        }

        this.props.immLoans.get('byId').forEach(immLoan => {

            const cardType = this.getCardType(immLoan);

            if (getLoansCreditsMortgagesProductBanners().find(banner => banner.id === cardType)) {
                output.push(cardType);
            }
        });

        return uniq(output);
    }

    buildDefaultBanner(banners, index, banner) {
        const newBanners = banners;
        const { loansAndMortgagesBannersData } = this.state;
        const { immContractEasyLoan } = this.props;

        const loansAndMortgagesBanner = loansAndMortgagesBannersData.find((item) => item.id === banner.id);
        const maxAmount = this.buildEasyAmount(immContractEasyLoan.get('maxAmount'));
        const formattedMaxAmount = getFormattedString(maxAmount);
        const easyLoanBannerTitle = formatText('bannerEasyLoan-customTaggingsTitlte', [formattedMaxAmount]);

        const taggingParams = {
            categoriaEvento: `${COMMERCIAL_WAFER_ADS_EVENT_CATEGORY}${banner.id}`,
            accionEvento: COMMERCIAL_ADS_ACTION_EVENT,
            tealiumEvent: COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
        }
        const taggingCustomData = {
            etiquetaEvento: formatText('common-moreInformation'),
            promotion_id: [banner.id],
            promotion_name: [banner.id],
            promotion_creative: [hasTranslation(banner.title)
                ? formatText(banner.title)
                : banner.id === LOANS_MORTGAGES_EASY_LOAN
                    ? easyLoanBannerTitle
                    : banner.title],
            promotion_position: [
                loansAndMortgagesBanner && loansAndMortgagesBanner.promotionPosition
                    ? loansAndMortgagesBanner.promotionPosition
                    : ''
            ],
        }
        const handleBannerClick = () => {
                if(banner.id === LOANS_MORTGAGES_EASY_LOAN) {
                    recordEasyLoanCBannerMoreInfo()
                }
            recordCommercialSpaceV2(taggingParams, taggingCustomData);
            this.props.history.push(banner.link);
        }

        newBanners.push(
            <ProductBanner
                key={`loans-credits-mortgages-product-banners-${index}`}
                id={banner.id}
                title={banner.title}
                subtitle={banner.subtitle}
                advantages={banner.advantages}
                collective={banner.collective}
                isCollectiveUser={banner.isCollective}
                collectiveName={banner.collectiveName}
                sidebarImgAlt={banner.sidebarImgAlt}
                sidebarImgUrl={__CONTACT_CENTER__ ? undefined : banner.sidebarImgUrl}
                onButtonClickHandle={handleBannerClick}
            />
        );

        return newBanners;
    }

    havePayrollLoan() {
        const { immPayrollLoanRecordStatus } = this.props;

        const success = immPayrollLoanRecordStatus.get('success');
        const cardDeniedVisible = immPayrollLoanRecordStatus.get('cardDeniedVisible');
        const status = immPayrollLoanRecordStatus.get('state');
        const isDenied = get(PAYROLL_LOAN_RECORD_STATUS, [status, 'checkFlag']);
        const canContract = isDenied && !cardDeniedVisible;

        // only display the product banner on this statuses.
        let hideBanner = get(PAYROLL_LOAN_RECORD_STATUS, status, false);

        // check the case of isDenied
        if (isDenied && canContract) {
            hideBanner = false;

        }

        return !hideBanner && success;
    }

    checkIsCollective(banner) {
        const { immCollectives } = this.props;
        const immCollectivesInfo = immCollectives.get('collectivesInfo');
        const alias = get(banner, 'collective.alias');
        const activeItem = getCollectiveByParams(alias, null, immCollectivesInfo);

        return activeItem ? {
            ...banner,
            isCollective: true,
            subtitle: get(banner, 'collective.subtitle', banner.sutitle),
            advantages: get(banner, 'collective.advantages', banner.advantages)
        } : banner;
    }

    buildPayrollBanner(banners, index, banner) {
        const { immPayrollLoanRecordStatus } = this.props;
        const status = immPayrollLoanRecordStatus.get('state');
        const addBanner = this.havePayrollLoan() && !status === bannerShow(status);
        const newBanner = this.checkIsCollective(banner);
        return addBanner ? this.buildDefaultBanner(banners, index, newBanner) : banners;
    }

    buildMortgageBanners(banners, index, banner) {
        const newBanner = this.checkIsCollective(banner);
        return this.buildDefaultBanner(banners, index, newBanner)
    }

    buildEasyAdvantages() {
        const { immContractEasyLoan } = this.props;

        const taeFrom = formatNumber(immContractEasyLoan.get('minTae').toFixed(2));
        const taeTo = formatNumber(immContractEasyLoan.get('maxTae').toFixed(2));
        const nominalType = immContractEasyLoan.get('tin');

        const immOpeningCommision = immContractEasyLoan.get('openingCommission');
        const openingCommission = immOpeningCommision.get('amount');

        const maximumAmount = this.buildEasyAmount(immContractEasyLoan.get('maxAmount'));
        const formattedMaximumAmount = getFormattedString(maximumAmount);

        const maxTerm = immContractEasyLoan.get('maxTerm');

        const openingCommissionMinimum = this.buildEasyAmount(immOpeningCommision.get('minimum'));
        const formattedOpeningCommissionMinimum = getFormattedString(openingCommissionMinimum);

        const formattedOpeningCommission = formatNumber(openingCommission.toFixed(2));

        const hasOpeningCommission = openingCommission > 0;
        const hasOpeningCommissionMinimun = openingCommissionMinimum.amount > 0;

        const FormattedNominalType = formatAmount(nominalType);

        let taeTin = {};

        if (hasOpeningCommission && hasOpeningCommissionMinimun) {
            taeTin = {
                text: 'bannerEasyLoan-advantage02VariableMinimum',
                injectedStrings: [FormattedNominalType, taeFrom, taeTo, formattedOpeningCommission, formattedOpeningCommissionMinimum]
            };
        } else if (hasOpeningCommission) {
            taeTin = {
                text: 'bannerEasyLoan-advantage02Variable',
                injectedStrings: [FormattedNominalType, taeFrom, taeTo, formattedOpeningCommission]
            };
        } else if (hasOpeningCommissionMinimun) {
            taeTin = {
                text: 'bannerEasyLoan-advantage02Minimum',
                injectedStrings: [FormattedNominalType, taeFrom, taeTo, formattedOpeningCommissionMinimum]
            };
        } else {
            taeTin = {
                text: 'bannerEasyLoan-advantage02Fixed',
                injectedStrings: [FormattedNominalType, taeFrom]
            };
        }

        return [
            {
                text: formatText('bannerEasyLoan-bannerEasyLoan_advantage01R15', [formattedMaximumAmount, maxTerm]),
                icon: 'icon-dinero'
            },
            {
                text: formatText(taeTin.text, taeTin.injectedStrings),
                icon: 'icon-porcentaje'
            },
            {
                text: 'bannerEasyLoan-advantage03',
                icon: 'icon-transparencia'
            },
            {
                text: 'bannerEasyLoan-advantage04',
                icon: 'icon-tiempo'
            }
        ];
    }

    buildEasyBanner(banners, index, banner) {
        const { immContractEasyLoan, immPayrollLoanRecordStatus, clientName } = this.props;
        const status = immPayrollLoanRecordStatus.get('state');
        const addBanner = immContractEasyLoan.get('stepReady') && !status === bannerShow(status);
        const newBanner = banner;
        if (addBanner) {
            const userName = toCamelCase(clientName).trim();
            const maxAmount = this.buildEasyAmount(immContractEasyLoan.get('maxAmount'));
            const formattedMaxAmount = getFormattedString(maxAmount);

            newBanner.title = formatText('bannerEasyLoan-title', [userName, formattedMaxAmount]);
            newBanner.advantages = this.buildEasyAdvantages();

            return this.buildDefaultBanner(banners, index, newBanner);
        }

        return banners;
    }

    buildRetailBanner(banners) {
        const newBanners = banners;
        const { immRetailLoan, immCommercialAds, immFlagBasedFeatures } = this.props;
        const { loansAndMortgagesBannersData } = this.state;
        const immAd = immCommercialAds.getIn(['byId', retailLoanCommons.BANNERID]);
        const isEnabled = immFlagBasedFeatures.get('loan-retail-enabled', false);
        const isRetail = immRetailLoan.get('products').size > 0;

        const loansAndMortgagesBanner = loansAndMortgagesBannersData.find((item) => item.id === LOAN_MORTGAGES_RETAIL_BANNER);

        const enableRetailLoan = !__CONTACT_CENTER__ || ENABLE_RETAIL_LOAN_HIRE_IN_CC;

        const retailBannerProductsTaggings = (item) => {
            const taggingParams = {
                categoriaEvento: `${COMMERCIAL_WAFER_ADS_EVENT_CATEGORY}${LOAN_MORTGAGES_RETAIL_BANNER}`,
                accionEvento: COMMERCIAL_ADS_ACTION_EVENT,
                tealiumEvent: COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
            }
            const taggingCustomData = {
                etiquetaEvento: `${item.get('field_buy_button')} ${item.get('title')}`,
                promotion_id: [LOAN_MORTGAGES_RETAIL_BANNER],
                promotion_name: [LOAN_MORTGAGES_RETAIL_BANNER],
                promotion_creative: [immAd.get('title')],
                promotion_position: [
                    loansAndMortgagesBanner && loansAndMortgagesBanner.promotionPosition
                        ? loansAndMortgagesBanner.promotionPosition
                        : ''
                ],
            }
            recordCommercialSpaceV2(taggingParams, taggingCustomData);
            this.props.history.push(`/myprofile/loans-mortgages/contract-retail-loan/${item.get('nid')}`);
        }

        const handleRetailBannerClick = () => {
            const taggingParams = {
                categoriaEvento: `${COMMERCIAL_WAFER_ADS_EVENT_CATEGORY}${LOAN_MORTGAGES_RETAIL_BANNER}`,
                accionEvento: COMMERCIAL_ADS_ACTION_EVENT,
                tealiumEvent: COMMERCIAL_ADS_CLICK_TEALIUM_EVENT,
            }
            const taggingCustomData = {
                etiquetaEvento: formatText('retailLoanCommon-seeAllEvents'),
                promotion_id: [LOAN_MORTGAGES_RETAIL_BANNER],
                promotion_name: [LOAN_MORTGAGES_RETAIL_BANNER],
                promotion_creative: [immAd.get('title')],
                promotion_position: [
                    loansAndMortgagesBanner && loansAndMortgagesBanner.promotionPosition
                        ? loansAndMortgagesBanner.promotionPosition
                        : ''
                ],
            }
            recordCommercialSpaceV2(taggingParams, taggingCustomData);
            this.props.history.push('/myprofile/loans-mortgages/contract-retail-loan');
        }

        if (immAd && isRetail && isEnabled) {
            newBanners.push(
                <ProductBanner
                    hasButton={enableRetailLoan}
                    customType="retail-loan"
                    eventName={EVENT_VIEW_ALL}
                    id="retail-loan"
                    key="loans-credits-mortgages-product-banners-retail-loan"
                    link="/myprofile/loans-mortgages/contract-retail-loan"
                    linkModifier="primary"
                    linkText="retailLoanCommon-seeAllEvents"
                    processType={PROC_RETAIL_LOAN}
                    sidebarImgAlt={immAd.get('title')}
                    sidebarImgUrl={__CONTACT_CENTER__ ? undefined : immAd.getIn(['fieldImageLarge', 'url'])}
                    subtitle={formatText("bannerEasyLoan-customDescription")}
                    title={formatText("bannerEasyLoan-customTitlte")}
                    onButtonClickHandle={handleRetailBannerClick}
                >
                    <RetailLoanCarousel
                        labels={configOkLoansCarousel(formatText)}
                        listItems={immRetailLoan.get('products')}
                        setItemProduct={this.redirectToBuyItem}
                        handleProductsClick={retailBannerProductsTaggings}
                    />
                </ProductBanner>
            );
        }

        return newBanners;
    }

    buildProductBanners(orderedProductBanners) {
        let banners = [];
        orderedProductBanners.map((banner, index) => {
            switch (banner.id) {
                case 'nominaLoan':
                    banners = this.buildPayrollBanner(banners, index, banner);
                    break;
                case LOANS_MORTGAGES_EASY_LOAN:
                    banners = this.buildEasyBanner(banners, index, banner);
                    break;
                case LOAN_MORTGAGES_RETAIL_BANNER:
                    banners = this.buildRetailBanner(banners, index, banner);
                    break;
                case LOANS_MORTGAGES_MORTGAGE_LOAN:
                    banners = this.buildMortgageBanners(banners, index, banner);
                    break;
                default:
                    banners = this.buildDefaultBanner(banners, index, banner);
                    break;
            }
        });
        return banners;
    }

    redirectToBuyItem(nid) {
        this.props.history.push(`/myprofile/loans-mortgages/contract-retail-loan/${nid}`);
    }

    validateTaggings(orderedProductBanners) {
        const { immCommercialAds, immContractEasyLoan, immFlagBasedFeatures, immPayrollLoanRecordStatus, immRetailLoan } = this.props;
        const isEasyLoanValid = immContractEasyLoan.get('hasEasyLoanSuccess');
        const isNominaLoanValid = immPayrollLoanRecordStatus.get('success');
        const immAd = immCommercialAds.getIn(['byId', retailLoanCommons.BANNERID]);
        const isProductsFetchingSuccess = immRetailLoan.get('isProductsFetchingSuccess');
        const isRetailProductsNotAvailable = immRetailLoan.get('isNotAvailable');

        if (!isNull(isEasyLoanValid) && isNominaLoanValid && immAd && (!isNull(isProductsFetchingSuccess) || isRetailProductsNotAvailable)) {
            const bannerData = [];
            const isEasyLoanBannerVisible = orderedProductBanners.filter((item) => item.id === LOANS_MORTGAGES_EASY_LOAN);
            const isMortagesBannerVisible = orderedProductBanners.filter((item) => item.id === LOANS_MORTGAGES_MORTGAGE_LOAN);
            const isPregrantedCreditBannerVisible = orderedProductBanners.filter((item) => item.id === 'pregrantedCredit');
            const isNominaLoanBannerVisible = orderedProductBanners.filter((item) => item.id === 'nominaLoan');
            const isRetailBannerVisible = orderedProductBanners.filter((item) => item.id === LOAN_MORTGAGES_RETAIL_BANNER);

            const isRetailBannerValid = immFlagBasedFeatures.get('loan-retail-enabled', false);
            const isRetailProductValid = immRetailLoan.get('products').size > 0;

            if (isEasyLoanBannerVisible.length) {
                const addBanner = immContractEasyLoan.get('stepReady');
                const easyLoanBanner = isEasyLoanBannerVisible[0];
                if (addBanner) {
                    const maxAmount = this.buildEasyAmount(immContractEasyLoan.get('maxAmount'));
                    const formattedMaxAmount = getFormattedString(maxAmount);

                    easyLoanBanner.title = formatText('bannerEasyLoan-customTaggingsTitlte', [formattedMaxAmount]);
                    bannerData.push(easyLoanBanner);
                }
            }

            if (isRetailBannerValid && isRetailProductValid && isRetailBannerVisible.length) {
                const retailBanner = {
                    ...isRetailBannerVisible[0],
                    title: immAd.get('title'),
                    subtitle: immAd.getIn(['body', 'value'])
                };
                bannerData.push(retailBanner);
            }

            if (isMortagesBannerVisible.length) {
                const mortageBanner = this.checkIsCollective(isMortagesBannerVisible[0]);
                bannerData.push(mortageBanner);
            }

            if (isNominaLoanBannerVisible.length) {
                const addBanner = this.havePayrollLoan();
                if (addBanner) {
                    const nominaLoanBanner = this.checkIsCollective(isNominaLoanBannerVisible[0]);
                    bannerData.push(nominaLoanBanner);
                }
            }

            if (isPregrantedCreditBannerVisible.length) {
                bannerData.push(isPregrantedCreditBannerVisible[0]);
            }

            const loansAndMortagesBanners = bannerData.map((item, index) => {
                return { ...item, promotionPosition: `${index + 1}` }
            });

            if (loansAndMortagesBanners.length) this.handleBannersTaggings(loansAndMortagesBanners);

            this.setState({ isAllBannersTagged: true, loansAndMortgagesBannersData: loansAndMortagesBanners });
        }
    }

    handleBannersTaggings(bannerData) {
        const { immCommercialAds } = this.props;
        const immAd = immCommercialAds.getIn(['byId', retailLoanCommons.BANNERID]);
        const taggingParams = {
            categoriaEvento: '',
            accionEvento: ACTION_EVENT_VIEW,
            tealiumEvent: COMMERCIAL_ADS_TEALIUM_EVENT,
        };
        const taggingCustomData = {
            promotion_id: [],
            promotion_name: [],
            promotion_creative: [],
            promotion_position: [],
        };
        const wafersIds = [];

        bannerData.forEach((banner) => {
            taggingCustomData.promotion_id.push(banner.id);
            taggingCustomData.promotion_name.push(banner.id);
            taggingCustomData.promotion_creative.push(banner.id === LOAN_MORTGAGES_RETAIL_BANNER
                ? immAd.get('title')
                : hasTranslation(banner.title)
                    ? formatText(banner.title)
                    : banner.title);
            taggingCustomData.promotion_position.push(banner.promotionPosition);
            wafersIds.push(banner.id);
        });

        if (wafersIds.length) {
            taggingParams.categoriaEvento = `${COMMERCIAL_WAFER_ADS_EVENT_CATEGORY}${wafersIds.join(', ')}`;
            recordCommercialSpaceV2(taggingParams, taggingCustomData);
        }
    }

    render() {
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode();
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode);
        const banners = this.buildProductBanners(orderedProductBanners);
        if (!this.state.isAllBannersTagged) this.validateTaggings(orderedProductBanners);

        return (
            <section className="loans-credits-mortgages-product-banners">
                <header className="loans-credits-mortgages-product-banners__header">
                    <FormattedText value="productBanner-meetLoansCreditsMortgages" />
                </header>
                {banners}
            </section>
        );
    }
}

LoansCreditsMortgagesProductBanners.propTypes = {
    immCollectives: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immCredits: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    immPayrollLoanRecordStatus: PropTypes.object.isRequired,
    clientName: PropTypes.string.isRequired,
    payrollLoanRecordDate: PropTypes.string.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    immCommercialAds: PropTypes.object.isRequired,
    immCollectiveMortgage: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(LoansCreditsMortgagesProductBanners);
